import { render, staticRenderFns } from "./OrderSku.vue?vue&type=template&id=c937c986"
import script from "./OrderSku.vue?vue&type=script&lang=js"
export * from "./OrderSku.vue?vue&type=script&lang=js"
import style0 from "./OrderSku.vue?vue&type=style&index=0&id=c937c986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports